import { render } from "./DietStatus.vue?vue&type=template&id=295152ea"
import script from "./DietStatus.vue?vue&type=script&lang=js"
export * from "./DietStatus.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__